import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
const normalizeModifierOrder = params => order => {
  const orderSpecified = Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(Data$dOrd.ordString)(a)()(m))(Data$dMap$dInternal.Leaf)(order);
  const existing = Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(Data$dOrd.ordString)(a)()(m))(Data$dMap$dInternal.Leaf)(Data$dSemigroup.concatArray(params.categoryModifiers)(params.productModifiers));
  const divisibilityMatches = modifierId => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(modifierId)(Data$dRecord.unsafeGet("modifiers")(params.catalogue));
    if ($0.tag === "Nothing") { return false; }
    if ($0.tag === "Just") { return Data$dRecord.unsafeGet("divisible")($0._1) === params.divisible; }
    $runtime.fail();
  };
  return Data$dArray.nubBy(Data$dOrd.ordString.compare)(Data$dArray.filter(v => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v)(existing);
    if ($0.tag === "Nothing") { return false; }
    if ($0.tag === "Just") { return true; }
    $runtime.fail();
  })(Data$dSemigroup.concatArray(Data$dArray.filter(a => (() => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(a)(orderSpecified);
    if ($0.tag === "Nothing") { return true; }
    if ($0.tag === "Just") { return false; }
    $runtime.fail();
  })() && divisibilityMatches(a))(params.categoryModifiers))(Data$dSemigroup.concatArray(Data$dArray.filter($0 => divisibilityMatches($0))(order))(Data$dArray.filter(a => (() => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(a)(orderSpecified);
    if ($0.tag === "Nothing") { return true; }
    if ($0.tag === "Just") { return false; }
    $runtime.fail();
  })() && divisibilityMatches(a))(params.productModifiers)))));
};
export {normalizeModifierOrder};
